if (!customElements.get('bs-circuito')) {
  customElements.define('bs-circuito', class extends HTMLElement {
    connectedCallback() {
      this.fixed = this.querySelector('.bs-circuito__fijo');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.details = [...this.querySelectorAll('.bs-circuito__estacion')];
      this.panels = this.details.map(d => d.querySelector('.bs-circuito__panel'));
      if (this.tabs.length !== 6) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.desktop = matchMedia('(min-width: 1024px)');
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', e => {
        const tab = e.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.go(this.tabs.indexOf(tab) + 1);
      }, { signal });
      this.addEventListener('keydown', e => {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0) return;
        const next = { ArrowRight: (i + 1) % 6, ArrowLeft: (i + 5) % 6, Home: 0, End: 5 }[e.key];
        if (next === undefined) return;
        e.preventDefault();
        this.tabs[next].focus({ preventScroll: true });
        if (this.pinned) this.go(next + 1);
      }, { signal });
      this.queue = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.read();
        });
      };
      document.addEventListener('scroll', this.queue, { capture: true, passive: true, signal });
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.mode(), 150);
      }, { signal });
      window.addEventListener('hashchange', () => {
        const n = this.destination(false);
        if (n) this.go(n, true);
      }, { signal });
      this.mode();
      const destination = this.destination();
      if (destination) this.go(destination, true);
      document.fonts?.ready.then(() => { if (this.isConnected) this.mode(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.frame);
    }
    destination(queryAllowed = true) {
      const hash = location.hash.match(/^#circuito-0([1-6])$/);
      const query = new URLSearchParams(location.search).get('estacion');
      return Number(hash?.[1] || (queryAllowed && /^[1-6]$/.test(query) ? query : 0));
    }
    top() {
      return (parseFloat(getComputedStyle(this.fixed).top) || 0) + (this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top);
    }
    mode() {
      this.scroller = window;
      for (let p = this.parentElement; p && p !== document.body; p = p.parentElement) {
        if (/(auto|scroll)/.test(getComputedStyle(p).overflowY) && p.scrollHeight > p.clientHeight) {
          this.scroller = p;
          break;
        }
      }
      const previous = this.n;
      this.classList.remove('is-tabs');
      this.classList.add('is-fijo');
      this.style.height = '';
      this.details.forEach((d, i) => {
        d.open = true;
        this.panels[i].hidden = false;
      });
      const viewport = this.scroller === window ? innerHeight : Math.min(innerHeight, this.scroller.clientHeight);
      this.pinned = this.fixed.offsetHeight <= viewport - parseFloat(getComputedStyle(this.fixed).top) - 12;
      this.classList.toggle('is-fijo', this.pinned);
      this.classList.toggle('is-tabs', !this.pinned && this.desktop.matches);
      this.tabbed = this.pinned || this.desktop.matches;
      if (this.pinned) {
        this.step = viewport * 0.5;
        this.style.height = `${this.fixed.offsetHeight + 5 * this.step}px`;
      }
      this.panels.forEach((panel, i) => {
        if (this.tabbed) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[i].id);
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
        }
      });
      this.activate(previous || (this.pinned ? 1 : 4), false);
      if (this.pinned) this.read();
    }
    read() {
      if (!this.pinned) return;
      const progress = Math.max(0, (this.top() - this.getBoundingClientRect().top) / this.step);
      const n = Math.min(6, 1 + Math.floor(progress));
      this.style.setProperty('--bs-tramo', Math.min(1, progress - (n - 1)));
      this.activate(n, false);
    }
    go(n, direct = false) {
      this.activate(n, true);
      if (this.pinned) {
        const offset = this.scroller === window ? scrollY : this.scroller.scrollTop;
        const start = offset + this.getBoundingClientRect().top - this.top();
        this.scroller.scrollTo({ top: start + (n - 1) * this.step + this.step * 0.25, behavior: this.reduce.matches || direct ? 'instant' : 'smooth' });
      } else if (direct) {
        this.details[n - 1].scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
    activate(n, direction) {
      if (direction && this.n && n !== this.n && !this.reduce.matches) this.dataset.dir = n > this.n ? 'adelante' : 'atras';
      if (this.reduce.matches) delete this.dataset.dir;
      this.n = n;
      this.style.setProperty('--bs-n', n);
      this.tabs.forEach((tab, i) => {
        const active = i + 1 === n;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-recorrida', i < n);
        this.details[i].classList.toggle('is-activa', active);
        this.details[i].classList.toggle('is-recorrida', i < n);
        this.panels[i].hidden = this.tabbed && !this.pinned && !active;
        this.panels[i].inert = this.tabbed && !active;
        this.details[i].open = this.tabbed || active;
      });
    }
  });
}
